/**
 * 功能: 审核功能权限组件
 */
<template lang="pug">
  el-button(
    :title="getTitle"
    round
    :type="statusType"
    :icon="icon"
    size="mini"
    @click="review"
    v-if="(single.status === 0 || single.status === -1) && hasEditAuth")
  el-button(
    :title="getTitle"
    round
    :type="statusType"
    :icon="icon"
    size="mini"
    @click="review"
    v-else-if="hasReviewAuth")

</template>

<script>
import api from '@/apis/apis'
import Enum from '@/apis/enum'
import passport from '@/javascripts/passport'
export default {
  name: 'review',
  props: {
    url: String,
    type: String,
    single: Object,
    title: String
  },
  data () {
    return {
      currentStatus: -2,
      icon: 'el-icon-document-checked',
      statusType: 'success'
    }
  },
  computed: {
    hasEditAuth () {
      if (this.url === '/video/review') {
        return passport.checkAuth([Enum.AUTH.VIDEO_REVIEW, Enum.AUTH.VIDEO_EDIT])
      } else if (this.url === '/article/review') {
        return passport.checkAuth([Enum.AUTH.ARTICLE_REVIEW, Enum.AUTH.ARTICLE_EDIT])
      } else {
        return passport.checkAuth([Enum.AUTH.REPORT_REVIEW, Enum.AUTH.REPORT_EDIT])
      }
    },
    hasReviewAuth () {
      if (this.url === '/video/review') {
        return passport.checkAuth([Enum.AUTH.VIDEO_REVIEW])
      } else if (this.url === '/article/review') {
        return passport.checkAuth([Enum.AUTH.ARTICLE_REVIEW])
      } else {
        return passport.checkAuth([Enum.AUTH.REPORT_REVIEW])
      }
    },
    // 提示信息
    getTitle () {
      const status = this.single.status
      if (this.title) {
        return this.title
      } else if (status === 0 || status === -1) {
        return '提交审核'
      } else if (status === 2) {
        return '回退修改'
      } else {
        return false
      }
    }
  },
  watch: {
    'single.status': {
      handler (val) {
        if (val === 0) { // 提交审核
          this.currentStatus = 1
          this.icon = 'el-icon-document-checked'
          this.statusType = 'primary'
        } else if (val === 1) { // 审核通过
          if (this.title === '通过') {
            this.currentStatus = 2
            this.icon = 'el-icon-check'
            this.statusType = 'success'
          } else {
            this.currentStatus = -1
            this.icon = 'el-icon-close'
            this.statusType = 'danger'
          }
        } else if (val === 2) { // 失败
          this.currentStatus = -1
          this.icon = 'el-icon-refresh-right'
          this.statusType = 'danger'
        } else if (val === -1) {
          this.currentStatus = 1
          this.icon = 'el-icon-document-checked'
          this.statusType = 'primary'
        } else { // 说明没有status, 点击就是提交审核
          this.currentStatus = 1
        }
      },
      immediate: true
    }
  },
  methods: {
    // 提交审核数据
    review () {
      this.checkSensitive().then((res) => {
        if (res && res.length) this.$emit('sensitive', res)
        else this.handleReview()
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },
    handleReview () {
      api.handleReview({ _id: this.single._id, status: this.currentStatus }, this.url).then(res => {
        const str = Enum.getLabel(this.currentStatus, Enum.STATUS)
        if (this.currentStatus === 2) {
          this.$emit('check', this.single._id)
        }
        this.handleResult(res, `${str}`, () => {
          this.$set(this.single, 'status', this.currentStatus)
        })
      }).catch(err => {
        this.$message({ type: 'error', message: err })
      })
    },
    // 敏感词检查
    checkSensitive () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return new Promise((resolve, reject) => {
        if (!this.single._id || !this.type) {
          resolve([])
          loading.close()
          return
        }
        api.checkSensitive({ id: this.single._id, type: this.type }).then(res => {
          console.log(res.data)
          if (res.data) {
            resolve(res.data)
          } else {
            resolve([])
          }
          loading.close()
        }).catch(err => {
          loading.close()
          reject(err)
        })
      })
    }
  }
}
</script>
